module.exports = __webpack_public_path__ + "static/media/exprt-03.38919b3f.jpg";